import { render, staticRenderFns } from "./EnumerationListCreate.vue?vue&type=template&id=0d2dea3e"
import script from "./EnumerationListCreate.vue?vue&type=script&lang=ts"
export * from "./EnumerationListCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports